const zoomWrapper = document.getElementById("zoom-container");
const zoomImg = document.getElementById("main-product-image");
 
let isZoomed = false;
 
zoomWrapper.addEventListener("click", () => {
  isZoomed = !isZoomed;
  zoomWrapper.classList.toggle("zoomed", isZoomed);
});
 
zoomWrapper.addEventListener("mousemove", (e) => {
  if (!isZoomed) return;
  const bounds = zoomWrapper.getBoundingClientRect();
  const x = ((e.clientX - bounds.left) / bounds.width) * 100;
  const y = ((e.clientY - bounds.top) / bounds.height) * 100;

  zoomImg.style.transformOrigin = `${x}% ${y}%`;
});
 
document.addEventListener("DOMContentLoaded", function () {
  const customQty = document.getElementById("custom-quantity");
  const shopifyQty = document.getElementById("shopify-quantity");
  
  // Sync whenever custom quantity changes
  customQty.addEventListener("input", function () {
    if (shopifyQty) shopifyQty.value = this.value;
  });
  
  // Optional: also sync on + / − buttons
  window.updateQty = function (change) {
    let current = parseInt(customQty.value) || 1;
    const newVal = Math.max(current + change, 1);
    customQty.value = newVal;
    if (shopifyQty) shopifyQty.value = newVal;
  };
    
  const thumbnails = document.querySelectorAll(".thumbnail-image");
  const mainImage = document.getElementById("main-product-image");

  thumbnails.forEach(thumb => {
    thumb.addEventListener("click", function () {
      mainImage.setAttribute("src", this.dataset.full);
      thumbnails.forEach(t => t.classList.remove("active"));
      this.classList.add("active");
    });
  });
});


const fakeStockMap = {};
function getFakeStock(variantId) {
  if (!fakeStockMap[variantId]) {
    fakeStockMap[variantId] = Math.floor(Math.random() * 7) + 1; // 1–10
  }
  return fakeStockMap[variantId];
}
 
  
function updateQty(change) {
  const qtyInput = document.getElementById('custom-quantity');
  let current = parseInt(qtyInput.value) || 1;
  qtyInput.value = Math.max(current + change, 1);
}

async function addToCart(event) {
  event.preventDefault();

  const form = event.currentTarget;
  const button = form.querySelector(".add-to-cart-btn");

  const qty = parseInt(document.getElementById('custom-quantity').value) || 1;
  const variantId = document.getElementById('selected-variant-id').value;

  if (!variantId) {
    alert("Please select a variant.");
    return;
  }

  // --- Create spinner dynamically ---
  let spinner = button.querySelector(".spinner");
  if (!spinner) {
    spinner = document.createElement("span");
    spinner.className = "spinner";
    button.appendChild(spinner);
  }

  // Show loading state
  button.disabled = true;
  spinner.style.display = "inline-block";

  try {
    // Add to cart
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });

    // Refresh cart drawer
    setTimeout(() => {
      refreshCartDrawer();
    }, 1000);
    

  } catch (err) {
    console.error("Error adding to cart:", err);
    alert("Something went wrong. Please try again.");
  } finally {
    // Hide spinner and re-enable
    button.disabled = false;
    spinner.style.display = "none";
  }
}

function refreshCartDrawer() {
  $('cart-drawer').removeClass('is-empty');
  $('cart-drawer').load(location.href + " #CartDrawer");
  $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
  // $(".cart-count-bubble").click();
  $("cart-drawer").addClass("active");
}

function findMatchingVariant() {
  return variants.find(variant => {
    return (!variant.option1 || selectedOptions[0] === variant.option1 || !selectedOptions[0]) &&
            (!variant.option2 || selectedOptions[1] === variant.option2 || !selectedOptions[1]) &&
            (!variant.option3 || selectedOptions[2] === variant.option3 || !selectedOptions[2]);
  });
}

let selectedOptions = {};

document.querySelectorAll('.swatch-item').forEach(swatch => {
  swatch.addEventListener('click', function() {
    const index = this.dataset.optionIndex;
    const value = this.dataset.optionValue;
    const position = this.dataset.optionPosition;
    const variantName = this.dataset.optionVariant;

    // highlight active
    document.querySelectorAll(`.swatch-item[data-option-index="${index}"]`)
      .forEach(el => el.classList.remove('active'));

    this.classList.add('active');

    // store selection
    selectedOptions[index] = value;

    // find matching variant
    const variant = findMatchingVariant()

    if (variant ) {
      // Update product image
      if (variant.featured_image) {
        document.querySelector('#main-product-image').src = variant.featured_image.src;
      }
      
      document.getElementById("price").innerHTML = '$'+(variant.price / 100).toFixed(2);
      
      document.getElementById('selected-variant-id').value = variant.id
      document.getElementById(`${variantName}_name`).innerHTML = value
    }

    // Get fake stock
    const fakeStock = getFakeStock(variant.id);

    // Width for progress bar
    const width = (fakeStock / 10) * 100 + "%";

    $(".stock_number").text(fakeStock);
    $(".progress-fill").css("width", width);
  });
});